
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stazione-sciistica",
      function () {
        return require("private-next-pages/stazione-sciistica.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stazione-sciistica"])
      });
    }
  